const _temp0 = require("../app.i18n.ts");
const _temp1 = require("../calendarpsa/calendarpsa.i18n.ts");

const _temp2 = require("../calendaruha/calendaruha.i18n.ts");

const _temp3 = require("../commontranslations/psaRoles.i18n.ts");
const _temp4 = require("../commontranslations/psaStatuses.i18n.ts");
const _temp5 = require("../commontranslations/uhaRoles.i18n.ts");
const _temp6 = require("../commontranslations/uhaStatuses.i18n.ts");

const _temp7 = require("../dashboard/dashboard.i18n.ts");
const _temp8 = require("../dashboard/dashboard.student.i18n.ts");

const _temp9 = require("../evaluation/evaluationactivities.i18n.ts");
const _temp10 = require("../evaluation/evaluationstudenttable.i18n.ts");
const _temp11 = require("../evaluation/evaluationtabs.i18n.ts");

const _temp12 = require("../hooks/useUnsavedChangesPrompt.i18n.ts");

const _temp13 = require("./commonTranslations.i18n.ts");

const _temp14 = require("../invite/invitePsa.i18n.ts");
const _temp15 = require("../invite/inviteUha.i18n.ts");

const _temp16 = require("../login/about.i18n.ts");
const _temp17 = require("../login/registration.i18n.ts");
const _temp18 = require("../login/selectRole.i18n.ts");
const _temp19 = require("../login/siktLogo.i18n.ts");
const _temp20 = require("../login/unknownUser.i18n.ts");
const _temp21 = require("../login/welcome.i18n.ts");

const _temp22 = require("../myinstitution/agreementtable.psa.i18n.ts");
const _temp23 = require("../myinstitution/myinstitution.uha.i18n.ts");
const _temp24 = require("../myinstitution/myorganization.psa.i18n.ts");

const _temp25 = require("../pagelayout/menu.i18n.ts");
const _temp26 = require("../pagelayout/toolbar.i18n.ts");

const _temp27 = require("../pages/pagenotfound.i18n.ts");

const _temp28 = require("../policy/godtabetingelser.i18n.ts");
const _temp29 = require("../policy/rightsandprivacy.i18n.ts");

const _temp30 = require("../practiceactivity/activity.psa.i18n.ts");
const _temp31 = require("../practiceactivity/activity.student.i18n.ts");
const _temp32 = require("../practiceactivity/activity.uha.i18n.ts");
const _temp33 = require("../practiceactivity/bestillingsliste.psa.i18n.ts");
const _temp34 = require("../practiceactivity/calendarCell.psa.i18n.ts");
const _temp35 = require("../practiceactivity/calendarCell.uha.i18n.ts");
const _temp36 = require("../practiceactivity/oppsummering.uha.i18n.ts");
const _temp37 = require("../practiceactivity/praksissteder.student.i18n.ts");
const _temp38 = require("../practiceactivity/registrering.i18n.ts");
const _temp39 = require("../practiceactivity/rolleliste.i18n.ts");
const _temp40 = require("../practiceactivity/agreements/agreementErrors.i18n.ts");
const _temp41 = require("../practiceactivity/agreements/agreements.i18n.ts");

const _temp42 = require("../practiceactivity/fordeling/fordeling.i18n.ts");

const _temp43 = require("../practiceactivity/vurdering/vurderingWrapper.i18n.ts");
const _temp44 = require("../practiceactivity/vurdering/vurderingsinnstillinger.i18n.ts");
const _temp45 = require("../practiceactivity/vurdering/vurderingskriterier.i18n.ts");


const _temp46 = require("../practiceplaces/addpracticeplace.i18n.ts");
const _temp47 = require("../practiceplaces/practiceplaces.i18n.ts");
const _temp48 = require("../practiceplaces/practiceplaceagreement/addpracticeplaceagreement.i18n.ts");
const _temp49 = require("../practiceplaces/practiceplaceagreement/agreementcontent.i18n.ts");
const _temp50 = require("../practiceplaces/practiceplaceagreement/agreementdetails.i18n.ts");
const _temp51 = require("../practiceplaces/practiceplaceagreement/agreementduplicatewarning.i18n.ts");
const _temp52 = require("../practiceplaces/practiceplaceagreement/agreementpermits.i18n.ts");
const _temp53 = require("../practiceplaces/practiceplaceagreement/agreementtabs.i18n.ts");
const _temp54 = require("../practiceplaces/practiceplaceagreement/practicetypes.i18n.ts");
const _temp55 = require("../practiceplaces/practiceplaceagreement/stedsections/praksisstedsection.i18n.ts");
const _temp56 = require("../practiceplaces/practiceplaceagreement/stedsections/studiestedsection.i18n.ts");


const _temp57 = require("../practiceplaces/practiceplaceprofile/practiceplaceprofile.i18n.ts");


const _temp58 = require("../practicetype/practiceplaceswithagreements.uha.i18n.ts");
const _temp59 = require("../practicetype/practicetype.uha.i18n.ts");
const _temp60 = require("../practicetype/practicetypes.uha.i18n.ts");

const _temp61 = require("../settings/settings.i18n.ts");

const _temp62 = require("../students/students.psa.i18n.ts");

const _temp63 = require("../userprofile/userprofile.i18n.ts");

const _temp64 = require("../admin/brukere/myUsers.i18n.ts");

const _temp65 = require("../admin/praksisstedsok/praksisstedsok.i18n.ts");

const _temp66 = require("../admin/studiestedbruker/addStudiestedbruker.i18n.ts");

const _temp67 = require("../admin/synkronisering/synkronisering.i18n.ts");

const _temp68 = require("../admin/systembruker/addSystembruker.i18n.ts");


const _temp69 = require("../components/button/button.i18n.ts");

const _temp70 = require("../components/calendar/calendar.i18n.ts");

const _temp71 = require("../components/datepicker/datePicker.i18n.ts");

const _temp72 = require("../components/dialog/confirmationDialog.i18n.ts");
const _temp73 = require("../components/dialog/informationDialog.i18n.ts");

const _temp74 = require("../components/fileupload/fileupload.i18n.ts");

const _temp75 = require("../components/icon/icons.i18n.ts");

const _temp76 = require("../components/indentation/indentation.i18n.ts");

const _temp77 = require("../components/input/autocomplete.i18n.ts");

const _temp78 = require("../components/notifications/userNotifications.i18n.ts");

const _temp79 = require("../components/table/alpTable.i18n.ts");


module.exports = {
  "app": _temp0,
  "calendarpsa":   {
    "calendarpsa": _temp1
  },
  "calendaruha":   {
    "calendaruha": _temp2
  },
  "commontranslations":   {
    "psaRoles": _temp3,
    "psaStatuses": _temp4,
    "uhaRoles": _temp5,
    "uhaStatuses": _temp6
  },
  "dashboard":   {
    "dashboard": _temp7,
    "dashboard.student": _temp8
  },
  "evaluation":   {
    "evaluationactivities": _temp9,
    "evaluationstudenttable": _temp10,
    "evaluationtabs": _temp11
  },
  "hooks":   {
    "useUnsavedChangesPrompt": _temp12
  },
  "i18n":   {
    "commonTranslations": _temp13
  },
  "invite":   {
    "invitePsa": _temp14,
    "inviteUha": _temp15
  },
  "login":   {
    "about": _temp16,
    "registration": _temp17,
    "selectRole": _temp18,
    "siktLogo": _temp19,
    "unknownUser": _temp20,
    "welcome": _temp21
  },
  "myinstitution":   {
    "agreementtable.psa": _temp22,
    "myinstitution.uha": _temp23,
    "myorganization.psa": _temp24
  },
  "pagelayout":   {
    "menu": _temp25,
    "toolbar": _temp26
  },
  "pages":   {
    "pagenotfound": _temp27
  },
  "policy":   {
    "godtabetingelser": _temp28,
    "rightsandprivacy": _temp29
  },
  "practiceactivity":   {
    "activity.psa": _temp30,
    "activity.student": _temp31,
    "activity.uha": _temp32,
    "bestillingsliste.psa": _temp33,
    "calendarCell.psa": _temp34,
    "calendarCell.uha": _temp35,
    "oppsummering.uha": _temp36,
    "praksissteder.student": _temp37,
    "registrering": _temp38,
    "rolleliste": _temp39,
    "agreements":     {
      "agreementErrors": _temp40,
      "agreements": _temp41
    },
    "fordeling":     {
      "fordeling": _temp42
    },
    "vurdering":     {
      "vurderingWrapper": _temp43,
      "vurderingsinnstillinger": _temp44,
      "vurderingskriterier": _temp45
    }
  },
  "practiceplaces":   {
    "addpracticeplace": _temp46,
    "practiceplaces": _temp47,
    "practiceplaceagreement":     {
      "addpracticeplaceagreement": _temp48,
      "agreementcontent": _temp49,
      "agreementdetails": _temp50,
      "agreementduplicatewarning": _temp51,
      "agreementpermits": _temp52,
      "agreementtabs": _temp53,
      "practicetypes": _temp54,
      "stedsections":       {
        "praksisstedsection": _temp55,
        "studiestedsection": _temp56
      }
    },
    "practiceplaceprofile":     {
      "practiceplaceprofile": _temp57
    }
  },
  "practicetype":   {
    "practiceplaceswithagreements.uha": _temp58,
    "practicetype.uha": _temp59,
    "practicetypes.uha": _temp60
  },
  "settings":   {
    "settings": _temp61
  },
  "students":   {
    "students.psa": _temp62
  },
  "userprofile":   {
    "userprofile": _temp63
  },
  "admin":   {
    "brukere":     {
      "myUsers": _temp64
    },
    "praksisstedsok":     {
      "praksisstedsok": _temp65
    },
    "studiestedbruker":     {
      "addStudiestedbruker": _temp66
    },
    "synkronisering":     {
      "synkronisering": _temp67
    },
    "systembruker":     {
      "addSystembruker": _temp68
    }
  },
  "components":   {
    "button":     {
      "button": _temp69
    },
    "calendar":     {
      "calendar": _temp70
    },
    "datepicker":     {
      "datePicker": _temp71
    },
    "dialog":     {
      "confirmationDialog": _temp72,
      "informationDialog": _temp73
    },
    "fileupload":     {
      "fileupload": _temp74
    },
    "icon":     {
      "icons": _temp75
    },
    "indentation":     {
      "indentation": _temp76
    },
    "input":     {
      "autocomplete": _temp77
    },
    "notifications":     {
      "userNotifications": _temp78
    },
    "table":     {
      "alpTable": _temp79
    }
  }
}